import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function BotDevelopment() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Helmet>
                <title>Bot Development Services | AI & Chatbot Solutions by Blockcryp</title>
                <meta
                    name="description"
                    content="Automate your business with Blockcryp's bot development services. We build AI chatbots, trading bots, and custom automation bots for Web3 and enterprise needs."
                />
                <meta
                    name="keywords"
                    content="bot development services, AI chatbot development, trading bot development, custom bot solutions, Web3 automation bots, Telegram bot development, crypto trading bot services, intelligent virtual assistants, enterprise bot development, chatbot development company"
                />
            </Helmet>
            {/* ---------- hero section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Crypto Arbitrage <span className="text-primary">Bot Development</span>
                            </motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Conveniently achieve your trading goals and yield the desired profit by automating your crypto trading with the help of our futuristic crypto trading bot development services.
                            </motion.p>

                            <motion.button
                                className="button theme_btn mt-lg-4 mt-0" type="submit"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                Talk To Our Experts
                            </motion.button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/botdevelopment/bot_hero2.webp"
                                    alt="Image 1"
                                    className="w-100"
                                />
                                {/* <img src="assets/images/botdevelopment/bot_hero.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Bot Development Profit section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center justify-content-between g-4">
                        <div className="col-lg-5">
                            <motion.div
                                className="d-flex justify-content-center"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/botdevelopment/arbitrage2.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/botdevelopment/arbitrage1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-semibold"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Crypto Arbitrage Bot for Maximum Profit</motion.h3>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >As a top-rated crypto trading bot development company, we build high-end automated arbitrage trading software with cutting-edge features and superior functionalities, enabling you to maximize your trading profit margin quite significantly. These bots set high standards with advanced technology, excellent performance, and enhanced security measures.</motion.p>
                                <motion.p
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Crypto arbitrage trading bot development plays a pivotal role in not only automating trading but also ensuring the effective execution of diverse trading strategies with the utmost ease and convenience. The bots designed by our cadre of crypto arbitrage bot development experts appropriately meet every individual's and crypto business’s requirements in the best possible manner.</motion.p>
                                <motion.button
                                    className="button theme_btn mt-lg-4 mt-0" type="submit"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Free Demo
                                </motion.button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- token model section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row justify-content-center mb-4 mb-lg-5">
                        <div className="col-xl-8 col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Bot Development ")}
                                    {splitTextToSpans("Services We Offer", "text-primary")}
                                </>
                            </ScrollFloat>
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Whether you are an entrepreneur looking to build a trading bot to integrate it into an existing platform or building an AI bot trading platform for yourself, we have got you covered.</motion.p>
                        </div>
                    </div>
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/botdevelopment/offer.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/botdevelopment/offer.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-2">
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Bot-as-a-Service(BaaS) :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Users can effectively utilize our cloud-based trading bot development models, regardless of their geographical location. Our highly customizable automated crypto trading bot development solutions can be tailored to match clients’ trading and compliance needs.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Trading Bot Consultation Services :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our trading bot consultation services are designed to give users a clearer picture of automated crypto trading. New entrants in the field can take advantage of our consultation services to realize the right path to profitable trades using an AI auto trading bot.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Custom AI Auto Trading Bot Development :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Ace crypto markets with our AI auto trading bot development solutions that leverage smart algorithms to analyze the best trades for optimal returns. Being a pioneering crypto trading bot development company, we ensure the integration of the best features.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >AI Auto Trading Bot Integration Services :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    We offer the highest quality automated AI trading bot integration services, where our expert team integrates third-party bots or bots developed by us into your required crypto exchange or other platforms at competitive prices.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* --------- Bot Development Services start -------- */}
            <section className="space80 services">
                <div className="container">
                    <div className="row justify-content-center mb-4 mb-lg-5">
                        <div className="col-10">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Our Crypto Arbitrage Trading Bot")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Services", "text-primary fw-bold")}
                                </>
                            </ScrollFloat>
                            <motion.p
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="text-center"
                            >
                                Harness the power of professionally built crypto arbitrage bot development solutions to capitalize on market discrepancies and execute <br className="d-md-block d-none" /> trades across multiple crypto exchanges seamlessly.
                            </motion.p>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center g-4">
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="about_card bot_card"
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/ser1-dark.svg"
                                            : "assets/images/botdevelopment/ser1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h3 className="text-start heading_h5 mb-3 fw-bold">
                                    Crypto Arbitrage Bot Development
                                </h3>
                                <div>
                                    <p className="mb-0">
                                        The crypto market is undoubtedly highly dynamic. Get freedom from constantly scouring for arbitrage opportunities by leveraging our automated arbitrage trading software that functions day and night so you don’t miss out on profitable opportunities.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="about_card bot_card"
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/ser2-dark.svg"
                                            : "assets/images/botdevelopment/ser2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h3 className="text-start heading_h5 mb-3 fw-bold">
                                    Bot-as-a-Service(BaaS)
                                </h3>
                                <div>
                                    <p className=" mb-0">
                                        We offer an avant trading Bot-as-a-service (BaaS) model, empowering businesses to deploy and manage their trading bots. When using our cloud-based trading bot, you need not worry about its security and maintenance, as it is on us.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="about_card bot_card"
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/ser3-dark.svg"
                                            : "assets/images/botdevelopment/ser3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h3 className="text-start heading_h5 mb-3 fw-bold">
                                    AI Arbitrage Trading Bot Development
                                </h3>
                                <div>
                                    <p className=" mb-0">
                                        AI enters the game and introduces real-time data analysis, pattern recognition, ultra-fast execution, multi-market, adaptability, and optimization capabilities. Leverage our trusted and robust crypto arbitrage AI bot to stay ahead of the game.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="about_card bot_card"
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/ser4-dark.svg"
                                            : "assets/images/botdevelopment/ser4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h3 className="text-start heading_h5 mb-3 fw-bold">
                                    Arbitrage Bot Consultation Services
                                </h3>
                                <div>
                                    <p className="mb-0">
                                        Get the guidance you need to venture into the world of trading with cutting-edge AI arbitrage trading bots. Our experienced consultants can assist you in strategy development, technology selection, algorithmic optimization, risk management, security assessment, etc.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                                className="about_card bot_card"
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/ser5-dark.svg"
                                            : "assets/images/botdevelopment/ser5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h3 className="text-start heading_h5 mb-3 fw-bold">
                                    Arbitrage Bot Integration Services
                                </h3>
                                <div>
                                    <p className="mb-0">
                                        Leverage our state-of-the-art arbitrage bot integration services to get exclusive crypto arbitrage AI bots integrated into your existing crypto exchange or trading bot platform. Our developers can also assist you with API configuration and risk management integration.
                                    </p>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Bot Development Process section start ---------- */}
            <section className="space80 why_choose_defi" >
                <div className="container">
                    <div className="row justify-content-between mb-4 mb-lg-5">
                        <div className="col-12">
                            <motion.h2
                                className="heading_h3 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Flash Loan Crypto Arbitrage Development: Process</motion.h2>
                            <motion.p
                                className=""
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Being an esteemed AI crypto trading bot development company, our team follows a coherent process to deliver unmatched results and efficiency. Here are some steps that our adept teams take to build a flash loan arbitrage bot:</motion.p>
                        </div>
                    </div>
                    <div className="row justify-content-between g-4">
                        <div className="col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_22 fw-semibold"><i className="fa-solid fa-circle-check pe-2"></i>Requirement Gathering and Analysis:</h5>
                                <p className="fw-normal text-muted mb-1">Collaboration with clients to gather requirements</p>
                                <p className="fw-normal text-muted mb-1">Market research, trend analysis, and competitor’s analysis</p>
                                <p className="fw-normal text-muted mb-1">Feasibility analysis of desired features, strategy, blockchain network, etc.</p>
                            </motion.div>
                        </div>
                        <div className="col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_22 fw-semibold"><i className="fa-solid fa-circle-check pe-2"></i>Architecture Design and Smart Contract Development:</h5>
                                <p className="fw-normal text-muted mb-1">Determining technology stack, smart contract structure, and trading algorithms</p>
                                <p className="fw-normal text-muted mb-1">Development of a flash loan arbitrage smart contract</p>
                                <p className="fw-normal text-muted mb-1">Manage smart contract interaction with various DeFi protocols</p>
                            </motion.div>
                        </div>
                        <div className="col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_22 fw-semibold"><i class="fa-solid fa-circle-check pe-2"></i>Trading Algorithm Implementation and Flash Loan Integration</h5>
                                <p className="fw-normal text-muted mb-1">Implementation of trading algorithms</p>
                                <p className="fw-normal text-muted mb-1">Setting parameters to automate trades</p>
                                <p className="fw-normal text-muted mb-1">Integration with flash loan protocols and frontend development</p>
                            </motion.div>
                        </div>
                        <div className="col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_22 fw-semibold"><i className="fa-solid fa-circle-check pe-2"></i>Quality Assurance and Final Deployment</h5>
                                <p className="fw-normal text-muted mb-1">Unit testing, integration testing, and simulated trading scenarios</p>
                                <p className="fw-normal text-muted mb-1">Setting up the infrastructure for arbitrage flash loan bot</p>
                                <p className="fw-normal text-muted mb-1">Deployment of smart contracts for arbitrage automation</p>
                            </motion.div>
                        </div>
                        <div className="col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <h5 className="text_22 fw-semibold"><i className="fa-solid fa-circle-check pe-2"></i>Monitoring and Optimization</h5>
                                <p className="fw-normal text-muted mb-1">Constant monitoring of performance to address any issues or bugs</p>
                                <p className="fw-normal text-muted mb-1">Optimization of bot’s performance based on client’s requirements</p>
                                <p className="fw-normal text-muted mb-1">Maintenance of effectiveness and profitability over time</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- Trading Bot section start ---------- */}
            < section className="space80 services" >
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 p-0 mb-4">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-bold text-center"
                            >
                                <>
                                    {splitTextToSpans(" Stunning Features of Our Crypto Arbitrage ")} <br className="d-md-block d-none" />
                                    {splitTextToSpans("Trading Bot", "text-primary fw-bold")}
                                </>
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Explore Our Comprehensive Crypto <span> Token Development Services </span></h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Check out some of the stunning features of our crypto arbitrage bot development solutions listed below.</motion.p>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/trad1-dark.svg"
                                            : "assets/images/botdevelopment/trad1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Automated Trading</h5>
                                <p>Our arbitrage trading bots are completely automated and are crafted to make proper trading decisions. The crypto arbitrage bots can be configured to track different crypto exchanges and automatically place trade orders.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/trad2-dark.svg"
                                            : "assets/images/botdevelopment/trad2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Arbitrage Trading</h5>
                                <p>Our crypto arbitrage bot development solutions allow users to conveniently configure their bots to carry out arbitrage trading as per their bespoke strategy, allowing them to make better profits in changing market conditions.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/trad3-dark.svg"
                                            : "assets/images/botdevelopment/trad3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Backtesting</h5>
                                <p>Users can easily and conveniently backtest their customized strategies with the help of the trading bots to ensure the strategies’ potential as well as accuracy before entering into live trading activities.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/trad4-dark.svg"
                                            : "assets/images/botdevelopment/trad4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Stop Loss</h5>
                                <p>Crypto arbitrage trading bots developed by our team allow users to modify and edit their existing trades at the time of active trading sessions with the help of the integrated stop-loss feature in the bots.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/trad5-dark.svg"
                                            : "assets/images/botdevelopment/trad5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Push Notifications</h5>
                                <p>Our crypto trading bot development solutions come with the feature of push notifications that allow users to get live updates regarding profits, signals, losses, and many more as per their preferences.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-start"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/botdevelopment/trad6-dark.svg"
                                            : "assets/images/botdevelopment/trad6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-3"
                                />
                                <h5 className="heading_h5 fw-semibold mb-3">Crypto Portfolio</h5>
                                <p>The crypto portfolio feature allows users to easily track their spending, active trading, the success of PNLs, cancel trades, and several other things that provide them with a clear picture of their activities.</p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section >
            {/* ---------- faq section start ---------- */}
            <section className="space60" >
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1.  How much time does it take to develop a crypto arbitrage bot?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The time taken in building a crypto arbitrage bot depends upon the complexity of the bot, the features to be included in it, and many others. Connect with our developers and discuss your requirements to get an estimated timeline for your crypto arbitrage trading bot development project.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2.  What are the automated crypto trading bot strategies used?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Here are some of the most effective strategies used by our esteemed cryptocurrency trading bot development company during the development of the majority of bots:
                                        </p>
                                        <ul className="">
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Copy trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Mirror trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Social Trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Simulated Trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>RSI crypto trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Moving average or MA trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Time-based trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Super trend trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Pivot reversal trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>MACD trading</li>
                                            <li className="d-flex align-items-center mb-1"><i className="fa-solid fa-circle text_10 pe-2"></i>Fibonacci retracement trading</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3.  What are the costs associated with crypto arbitrage bot development?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            The cost of building a crypto arbitrage trading bot varies from one project to another. It is because of different factors that determine the cost, such as the type of bot, its complexity, its features, its functionalities, and many more. Connect with our team of experts to discuss your crypto trading bot development requirements and get the best quote.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4.  Can I integrate the trading bot into any platform?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Yes, you can integrate the trading bot developed by our team into any platform, provided that the platform supports integration from any third parties. Talk to the expert team and request a free consultation.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5.  Can you create a bot for a specific currency?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Yes, we offer customized crypto trading bots development solutions where we can help you build a trading bot for a specific currency and a specific purpose. Give us a call to learn more about our customized solutions.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 5 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(5)}>
                                        <span className="text_20 pe-4">
                                            6.   How do I build an arbitrage crypto bot?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Crypto arbitrage trading bot development is easily achievable for someone with decent technical knowledge. However, for those with limited or no experience, it is suitable to hire an experienced crypto trading bot development company, as it involves knowledge of the choice of programming language, APIs, exchanges, etc. Architecture design, development, testing, and deployment also demand technical expertise.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
